<template>
  <div class="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style lang="less">
.app{
  width: 100%;
  // height: 100%;
  // overflow-y: auto;
}
</style>
